export default "__VITE_ASSET__5SRsfNUl__"